// import React, { useState } from "react";
// import { FaStar } from "react-icons/fa";

// const Contactsupplier = () => {
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [review, setReview] = useState({
//     title: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setReview({ ...review, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!rating || !review.message) {
//       alert("Please provide rating and review");
//       return;
//     }

//     console.log({
//       rating,
//       ...review,
//     });

//     alert("Review submitted successfully!");
//   };

//   return (
//     <div className="container reviewpage">
//       <div className="row justify-content-center">
//         <div className="col-lg-12">
//           <div className="card shadow-sm p-4">
//             <h4 className="mb-3">Contact Supplier</h4>

//             {/* Product Info */}
//             <div className="d-flex align-items-center mb-4">
//               <img
//                 src="https://via.placeholder.com/80"
//                 alt="product"
//                 className="rounded border me-3"
//               />
//               <div>
//                 <h6 className="mb-1">Wireless Headphones</h6>
//                 <small className="text-muted">Order ID: #45821</small>
//               </div>
//             </div>

//             {/* Rating */}
//             {/* <div className="mb-3">
//               <label className="form-label">Your Rating</label>
//               <div>
//                 {[...Array(5)].map((_, index) => {
//                   const value = index + 1;
//                   return (
//                     <FaStar
//                       key={value}
//                       size={28}
//                       style={{ marginRight: 8, cursor: "pointer" }}
//                       color={value <= (hover || rating) ? "#ffc107" : "#ddd"}
//                       onClick={() => setRating(value)}
//                       onMouseEnter={() => setHover(value)}
//                       onMouseLeave={() => setHover(0)}
//                     />
//                   );
//                 })}
//               </div>
//             </div> */}

//             {/* Review Title */}
//             <div className="mb-3">
//               <label className="form-label"> Subject</label>
//               <input
//                 type="text"
//                 name="title"
//                 className="form-control"
//                 placeholder=""
//                 onChange={handleChange}
//               />
//             </div>

//             {/* Review Message */}
//             <div className="mb-3">
//               <label className="form-label">Your Problem</label>
//               <textarea
//                 className="form-control"
//                 rows="4"
//                 name="message"
//                 placeholder="Write your experience about the product..."
//                 onChange={handleChange}
//               ></textarea>
//             </div>

//             {/* Image Upload */}
//             <div className="mb-4">
//               <label className="form-label">Upload Images (optional)</label>
//               <input type="file" className="form-control" multiple />
//             </div>

//             {/* Submit */}
//             <div className="text-center">
//             <button className="button3 fw-semibold">
//               Submit Review
//             </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contactsupplier;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const Contactsupplier = () => {
  const { productId, sellerId } = useParams();
  const navigate = useNavigate();

  const [review, setReview] = useState({ title: "", message: "" });
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (productId) fetchProduct();
  }, [productId]);

  const fetchProduct = async () => {
    try {
      const formData = new FormData();
      formData.append("product_id", productId);

      const res = await fetch(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/create_get_product_by_id",
        { method: "POST", body: formData }
      );
      console.log("PRODUCT ID:", productId)

      const result = await res.json();
      console.log("API Response:", result);
      if (result.status) setProduct(result.data);
    } catch (err) {
      console.error("Product fetch error", err);
    }
  };

  const handleChange = (e) =>
    setReview({ ...review, [e.target.name]: e.target.value });

  const handleImageChange = (e) =>
    setImages([...e.target.files]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = localStorage.getItem("user_id");

    if (!review.title || !review.message) {
      alert("Please fill subject and problem");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("user_id", userId);
      formData.append("product_id", productId);
      formData.append("seller_id", sellerId);
      formData.append("subject", review.title);
      formData.append("your_problem", review.message);

      images.forEach((img) =>
        formData.append("multi_image[]", img)
      );

      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/add_contact_supplier",
        formData
      );

      if (res.data.status) {
        alert("Contact supplier request sent");
        navigate(-1);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const productImage =
    product?.multi_image?.[0]
      ? `https://cyberathon.com/multivendor/${product.multi_image[0]}`
      : "https://via.placeholder.com/80";

  return (
    <div className="container reviewpage">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="card shadow-sm p-4" style={{ position: "relative" }}>

            {/* Close button */}
            <button
              onClick={() => navigate(-1)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                border: "none",
                background: "transparent",
                fontSize: "22px",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            <h4 className="mb-3">Contact Supplier</h4>

            <div className="d-flex align-items-center mb-4">
              <img src={productImage} className="rounded border me-3" style={{ width: 80 }} />
              <div>
                <h6 className="mb-1">{product?.product_name}</h6>
                <small className="text-muted">Product ID: #{productId}</small>
              </div>
            </div>

            {/* Subject */}
            <div className="mb-3">
              <label className="form-label"> Subject</label>
              <input
                type="text"
                name="title"
                className="form-control"
                placeholder=""
                value={review.title}
                onChange={handleChange}
              />
            </div>

            {/* Message */}
            <div className="mb-3">
              <label className="form-label">Your Problem</label>
              <textarea
                className="form-control"
                rows="4"
                name="message"
                placeholder="Write your experience about the product..."
                value={review.message}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Image Upload */}
            <div className="mb-4">
              <label className="form-label">Upload Images (optional)</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={handleImageChange}
              />
            </div>

            {/* Submit */}
            <div className="text-center">
              <button
                className="button3 fw-semibold"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit Review"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactsupplier;
